import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Services() {
  const services = [
    {
      title: 'Paving Estimate',
      description: 'Get accurate cost estimates for asphalt driveways, pavement projects, and Lincoln NE paving costs per square foot.',
      icon: 'ri-calculator-line',
      link: '/services/paving-estimate',
      image: 'https://public.readdy.ai/ai/img_res/c8047e54024fb16ee8f4339e9982640b.jpg',
    },
    {
      title: 'Maintenance Services',
      description: 'Asphalt repairs, sealcoating, resurfacing, and crack filling to extend your pavement lifespan.',
      icon: 'ri-tools-line',
      link: '/services/maintenance-services',
      image: 'https://readdy.ai/api/search-image?query=asphalt%20maintenance%20work%20showing%20sealcoating%20application%20and%20crack%20repair%20on%20driveway%20with%20professional%20equipment%20and%20workers%20in%20Lincoln%20Nebraska%20with%20clean%20simple%20light%20background&width=600&height=400&seq=13&orientation=landscape',
    },
    {
      title: 'Products',
      description: 'Concrete curbs, recycled asphalt, hot tar & chip, gravel, and quality base materials for all paving projects.',
      icon: 'ri-stack-line',
      link: '/services/products',
      image: 'https://readdy.ai/api/search-image?query=paving%20materials%20and%20products%20including%20concrete%20curbs%20recycled%20asphalt%20gravel%20and%20base%20materials%20displayed%20professionally%20with%20clean%20simple%20light%20background%20showing%20quality%20construction%20supplies&width=600&height=400&seq=14&orientation=landscape',
    },
    {
      title: 'Commercial Asphalt Paving',
      description: 'Commercial concrete repair, parking lot paving, and asphalt sealing for businesses in Lincoln.',
      icon: 'ri-building-line',
      link: '/services/commercial-asphalt',
      image: 'https://readdy.ai/api/search-image?query=large%20commercial%20parking%20lot%20paving%20project%20with%20heavy%20machinery%20and%20workers%20laying%20fresh%20asphalt%20for%20business%20property%20in%20Lincoln%20Nebraska%20with%20clean%20simple%20light%20background&width=600&height=400&seq=15&orientation=landscape',
    },
    {
      title: 'Asphalt Repair',
      description: 'Lincoln NE asphalt repair near me, crack repair, patching, and restoration services for damaged pavement.',
      icon: 'ri-hammer-line',
      link: '/services/asphalt-repair',
      image: 'https://readdy.ai/api/search-image?query=asphalt%20repair%20work%20showing%20workers%20patching%20and%20fixing%20damaged%20pavement%20with%20professional%20tools%20and%20hot%20asphalt%20mix%20in%20Lincoln%20Nebraska%20with%20clean%20simple%20light%20background&width=600&height=400&seq=16&orientation=landscape',
    },
    {
      title: 'Concrete Driveway',
      description: 'Concrete driveway repair, installation, and stamped concrete services in Lincoln NE.',
      icon: 'ri-road-map-line',
      link: '/services/concrete-driveway',
      image: 'https://readdy.ai/api/search-image?query=fresh%20concrete%20driveway%20installation%20with%20workers%20smoothing%20and%20finishing%20gray%20concrete%20surface%20on%20residential%20property%20in%20Lincoln%20Nebraska%20with%20clean%20simple%20light%20background&width=600&height=400&seq=17&orientation=landscape',
    },
    {
      title: 'Sealcoating & Resurfacing',
      description: 'Lincoln NE asphalt sealcoating near me and pavement resurfacing to protect your investment.',
      icon: 'ri-paint-brush-line',
      link: '/services/sealcoating',
      image: 'https://readdy.ai/api/search-image?query=asphalt%20sealcoating%20application%20process%20with%20workers%20applying%20protective%20black%20coating%20to%20driveway%20surface%20using%20professional%20equipment%20in%20Lincoln%20Nebraska%20with%20clean%20simple%20light%20background&width=600&height=400&seq=18&orientation=landscape',
    },
    {
      title: 'Pothole & Crack Repair',
      description: 'Lincoln NE pothole repair near me and emergency asphalt crack repair services available.',
      icon: 'ri-alert-line',
      link: '/services/pothole-repair',
      image: 'https://readdy.ai/api/search-image?query=pothole%20repair%20work%20showing%20workers%20filling%20large%20pavement%20hole%20with%20hot%20asphalt%20mix%20and%20professional%20tools%20in%20Lincoln%20Nebraska%20with%20clean%20simple%20light%20background&width=600&height=400&seq=19&orientation=landscape',
    },
    {
      title: 'Commercial Parking Lot',
      description: 'Lincoln NE parking lot striping, resurfacing, and complete commercial parking lot services.',
      icon: 'ri-parking-box-line',
      link: '/services/parking-lot',
      image: 'https://readdy.ai/api/search-image?query=commercial%20parking%20lot%20with%20fresh%20striping%20and%20line%20painting%20work%20showing%20professional%20parking%20space%20markings%20in%20Lincoln%20Nebraska%20with%20clean%20simple%20light%20background&width=600&height=400&seq=20&orientation=landscape',
    },
    {
      title: 'Costs & Estimates',
      description: 'Lincoln NE paving cost per square foot and free paving quotes for all asphalt and concrete projects.',
      icon: 'ri-money-dollar-circle-line',
      link: '/services/costs-estimates',
      image: 'https://readdy.ai/api/search-image?query=cost%20estimate%20document%20and%20calculator%20showing%20paving%20project%20pricing%20and%20budget%20planning%20for%20asphalt%20driveway%20in%20Lincoln%20Nebraska%20with%20clean%20simple%20light%20background&width=600&height=400&seq=21&orientation=landscape',
    },
    {
      title: 'Best/Rated Contractors',
      description: 'Lincoln NE best asphalt contractor and top paving companies with verified reviews and ratings.',
      icon: 'ri-star-line',
      link: '/services/best-contractors',
      image: 'https://readdy.ai/api/search-image?query=award%20winning%20paving%20contractor%20team%20with%20five%20star%20rating%20badges%20and%20quality%20certification%20showing%20professional%20excellence%20in%20Lincoln%20Nebraska%20with%20clean%20simple%20light%20background&width=600&height=400&seq=22&orientation=landscape',
    },
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-24 sm:pt-32 pb-12 sm:pb-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-primary-500 text-xs sm:text-sm mb-3 sm:mb-4 tracking-wider">Home / Services</p>
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-4 sm:mb-6 leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              OUR SERVICES
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed px-4">
              Professional asphalt and concrete paving services for Lincoln, Nebraska
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-12 sm:py-16 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {services.map((service, index) => (
              <Link
                key={index}
                to={service.link}
                className="group bg-white border-2 border-gray-200 rounded-2xl overflow-hidden hover:border-primary-600 hover:shadow-2xl transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-40 sm:h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-primary-600 rounded-full flex items-center justify-center">
                      <i className={`${service.icon} text-xl sm:text-2xl text-white`}></i>
                    </div>
                  </div>
                </div>
                <div className="p-4 sm:p-6">
                  <h3 className="text-lg sm:text-xl md:text-2xl font-bold mb-2 sm:mb-3 text-gray-900 group-hover:text-primary-600 transition-colors leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-3 sm:mb-4 text-sm sm:text-base">
                    {service.description}
                  </p>
                  <div className="flex items-center text-primary-600 font-semibold text-sm sm:text-base">
                    <span>Learn More</span>
                    <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 md:py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 text-gray-900 leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Need a Paving Quote?
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 mb-6 sm:mb-8 leading-relaxed">
            Get your free estimate today! We provide detailed quotes for all asphalt and concrete projects in Lincoln, NE.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:3084705637" className="bg-primary-600 text-white px-8 sm:px-10 py-4 rounded-lg font-semibold hover:bg-primary-700 transition-colors text-base sm:text-lg whitespace-nowrap cursor-pointer min-h-[56px] flex items-center justify-center">
              CALL (308) 470-5637
            </a>
            <Link to="/contact" className="bg-gray-900 text-white px-8 sm:px-10 py-4 rounded-lg font-semibold hover:bg-gray-800 transition-colors text-base sm:text-lg whitespace-nowrap cursor-pointer min-h-[56px] flex items-center justify-center">
              REQUEST QUOTE
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}